import React from "react";
import LookupField from "./LookupField";
import { PARTNER_LOOKUP } from "./lookupConfigs";

/** Read-only input + search icon; value is always a `partner_id` chosen from the partner table. */
export default function PartnerLookupField(props) {
  return <LookupField config={PARTNER_LOOKUP} placeholder="Search Partner" {...props} />;
}
